import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { fadeInUp, standardViewport } from '../../utils/animation';
import './SectionTitle.scss';

const SectionTitle = ({ children, accent, className = '', light }) => {
  // Determinarea clasei de accent
  let accentClass = '';
  if (accent) {
    if (accent === '#204710') accentClass = 'accent-secondary';
    else if (accent === '#604020') accentClass = 'accent-dark';
    else accentClass = 'accent-primary';
  }
  
  // Combinarea claselor
  const titleClassName = `section-title ${accentClass} ${light ? 'light' : ''} ${className}`;
  
  return (
    <motion.h2
      className={titleClassName}
      initial="hidden"
      whileInView="visible"
      viewport={standardViewport}
      variants={fadeInUp}
    >
      {children}
    </motion.h2>
  );
};

SectionTitle.propTypes = {
  children: PropTypes.node.isRequired,
  accent: PropTypes.string,
  className: PropTypes.string,
  light: PropTypes.bool
};

export default SectionTitle;
